<template>
  <svg viewBox="4 0 24 24" fill="none" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 3C13 1.34315 14.3431 0 16 0C17.6569 0 19 1.34315 19 3V11C19 12.6569 17.6569 14 16 14C14.3431 14 13 12.6569 13 11V3Z"
      fill="#0F766E"
    />
    <path
      d="M17 17.9291C20.3923 17.4439 23 14.5265 23 11C23 10.4477 22.5523 10 22 10C21.4477 10 21 10.4477 21 11C21 13.7614 18.7614 16 16 16C13.2386 16 11 13.7614 11 11C11 10.4477 10.5523 10 10 10C9.44772 10 9 10.4477 9 11C9 14.5265 11.6077 17.4439 15 17.9291V20H12C11.4477 20 11 20.4477 11 21C11 21.5523 11.4477 22 12 22H20C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20H17V17.9291Z"
      fill="#0F766E"
    />
    <line x1="1.30176" y1="3.75006" x2="29.8806" y2="20.2501" stroke="#0F766E" stroke-width="2" />
  </svg>
</template>
